import styled, { css } from 'styled-components'
import { TypographyComponent } from '../../components/Typography'

export const ContainerFlex = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 80%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const Title = styled.h1(
  ({ theme }) => css`
    font-size: ${theme.typograph.fontsize.h8};
  `
)

export const Typography = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      font-weight: 300;

      span {
        font-weight: 700;
      }
    }
  `
)

export const Info = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      font-weight: 700;
    }
  `
)

export const ContentImage = styled.div(
  ({ theme }) => css`
    @media (max-width: ${theme.screen.small}) {
      display: none;
    }
  `
)

export const ContainerImage = styled.div(
  ({ theme }) => css`
    @media (max-width: ${theme.screen.medium}) {
      display: none;
    }
  `
)

export const ContainerImageLogo = styled.div(
  ({ theme }) => css`
    @media (max-width: ${theme.screen.small}) {
    }
  `
)

export const DownloadButton = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.primary.main70};
    border-top-right-radius: ${theme.layout.borderRadius.small};
    border-bottom-right-radius: ${theme.layout.borderRadius.small};
    display: flex;
    align-items: center;
    gap: ${theme.layout.gap.medium};
    cursor: pointer;
    width: 50%;

    @media (max-width: ${theme.screen.small}) {
      width: 100%;
    }

    span {
      font-size: ${theme.typograph.fontsize.h4};
      text-transform: uppercase;
    }
  `
)

export const ButtonIcon = styled.div(
  ({ theme }) => css`
    display: flex;
    background: ${theme.colors.primary.main70};
    padding: ${theme.layout.padding.medium};
    height: 100%;

    svg {
      color: #ffffff;
    }
  `
)

export const Link = styled.div(({ theme }) => css``)

export const ModalBox = styled.div(
  ({ theme }) => css`
    padding: ${theme.layout.padding.medium};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    background: ${theme.colors.base.white};
    width: 100%;
    gap: ${theme.layout.gap.small};

    @media (max-width: ${theme.screen.small}) {
      width: 90%;
    }
  `
)

export const ModalTitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h8};
      font-weight: 700;
      color: ${theme.colors.primary.main};

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h6};
      }
    }
  `
)

export const ModalDescription = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      text-align: start;
      width: 100%;
      font-weight: 700;
      margin-top: ${theme.layout.margin.base * 6}rem;
    }
  `
)

export const ModalBoxButtons = styled.div(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    right: 0;
    display: flex;
    gap: ${theme.layout.gap.medium};
    justify-content: flex-end;
    width: 100%;
    padding: ${theme.layout.padding.medium} 0;
    background-color: ${theme.colors.base.white};
    z-index: 1;

    @media (max-width: ${theme.screen.small}) {
      justify-content: space-between;
    }
  `
)
